import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import {
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES,
} from "utils/constants/locales.constants";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: Object.values(SUPPORTED_LANGUAGES),
    debug: false,
    detection: {
      order: ["queryString", "cookie"],
      cache: ["cookie"],
    },
    ns: ["common"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
